export default __webpack_public_path__ + "static/media/transaction-icon.7abca84a.png";